module.exports = __webpack_public_path__ + "img/safira.ac6506e3.png";